"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceDataSets = void 0;
var tslib_1 = require("tslib");
var MetaConverter_1 = require("../../../convertors/fromBackend/MetaConverter");
var DataSetConverter_1 = require("../../../convertors/fromBackend/DataSetConverter");
var BearWorkspaceDataSets = /** @class */ (function () {
    function BearWorkspaceDataSets(authCall, workspace) {
        this.authCall = authCall;
        this.workspace = workspace;
    }
    BearWorkspaceDataSets.prototype.getDatasets = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authCall(function (sdk) { return sdk.catalogue.loadDataSets(_this.workspace); })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.map(DataSetConverter_1.convertDataSet)];
                }
            });
        });
    };
    BearWorkspaceDataSets.prototype.getAllDatasetsMeta = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var datasetsResult;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authCall(function (sdk) {
                            return sdk.project.getDatasets(_this.workspace);
                        })];
                    case 1:
                        datasetsResult = _a.sent();
                        return [2 /*return*/, datasetsResult.map(function (dataset) {
                                return MetaConverter_1.convertMetadataObjectXrefEntry("dataSet", dataset);
                            })];
                }
            });
        });
    };
    return BearWorkspaceDataSets;
}());
exports.BearWorkspaceDataSets = BearWorkspaceDataSets;
//# sourceMappingURL=index.js.map